<template>
  <div class="menu-block">
    <footer-links v-for="block in blocks" :key="blocks[block]">
      <template v-slot:title>{{ block.title }}</template>

      <nuxt-link
        v-for="link in block.links"
        :key="link.label"
        :to="link.isDocument ? link.url : localePath(link.url)"
        :target="link.isDocument ? '_blank' : null"
        rel="noreferrer noopener"
        class="menu-link">
        {{ link.label }}
      </nuxt-link>
    </footer-links>
  </div>
</template>
<script>
import FooterLinks from '~/components/footer/footer-links';
import { WEB_ROUTES } from '~/utils/webConfig';

export default {
  name: 'FooterMenu',
  components: { FooterLinks },
  computed: {
    procedureLink() {
      return `/documents/procedure_${this.$i18n.locale}.pdf`;
    },

    scammersLink() {
      return `/documents/scammers_${this.$i18n.locale}.pdf`;
    },

    blocks() {
      return [
        {
          title: this.$t('footer.company-title'),
          links: [
            { label: this.$t('footer.contacts'), url: WEB_ROUTES.CONTACT },
            { label: this.$t('footer.about-us'), url: WEB_ROUTES.ABOUT },
          ],
        },
        {
          title: this.$t('footer.clients-title'),
          links: [
            { label: this.$t('footer.how-apply'), url: WEB_ROUTES.HOW_TO_APPLY },
            { label: this.$t('footer.how-repay'), url: WEB_ROUTES.HOW_TO_REPAY },
            { label: this.$t('footer.documents'), url: WEB_ROUTES.DOCUMENTS },
            { label: this.$t('footer.procedure'), url: this.procedureLink, isDocument: true },
            { label: this.$t('footer.scammers'), url: this.scammersLink, isDocument: true },
          ],
        },
      ];
    },
  },
};
</script>

<style lang="scss" scoped>
.menu-block {
  @include tablet {
    display: flex;
    width: 50%;
    justify-content: space-between;
  }

  & > * {
    @include tablet {
      width: 50%;
    }
  }
}

.menu-link {
  font-size: 14px;
  color: map-get($colors, white);
  opacity: 0.8;
  padding-right: 16px;
  margin-bottom: 16px;

  @include mobile {
    font-size: 16px;
  }
}
</style>
